import React, { SVGProps } from 'react';

export const EditIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.75 7.231a2.728 2.728 0 0 0-.806-1.948l-2.228-2.228a2.732 2.732 0 0 0-1.948-.806 2.73 2.73 0 0 0-1.945.81L2.469 15.47a.747.747 0 0 0-.219.529v5c0 .414.336.75.75.75h5a.753.753 0 0 0 .529-.218L20.94 9.176c.523-.518.81-1.209.811-1.945ZM7.69 20.25H3.75v-3.94l8.993-9.034 3.982 3.981L7.69 20.25ZM19.882 8.114l-2.094 2.085-3.987-3.986 2.085-2.095c.236-.237.55-.367.885-.368h.001c.334 0 .648.13.885.366l2.228 2.228a1.247 1.247 0 0 1-.003 1.77ZM21.75 21a.75.75 0 0 1-.75.75h-7a.75.75 0 0 1 0-1.5h7a.75.75 0 0 1 .75.75Z"
      />
    </svg>
  );
};
